import { MealCardProps } from "./MealCard.types";

import { imagePath } from "../../../lib/contants";
import { useCart } from "../../../lib/context/cart/CartContext";
import { useTrackEvent } from "../../../lib/tracking/useTrack";
import { Button } from "../../atoms/Button";
import { AddIcon } from "../../atoms/icons/AddIcon";
import { PlusIcon } from "../../atoms/icons/PlusIcon";
import { StarIcon } from "../../atoms/icons/StarIcon";
import { TrashIcon } from "../../atoms/icons/TrashIcon";

import styles from './MealCard.module.css';

export const MealCard = ({ data }: MealCardProps) => {
    const trackEvent = useTrackEvent();
    const { getMealById, addMealToCart, removeMealFromCart } = useCart();
    const { id, name, image, calories, chef } = data;
    const mealInCart = getMealById(id);

    const handleAddMeal = () => {
        console.log('toggle add meal', id)
        trackEvent('add_meal', {
            mealId: id,
            amount: mealInCart?.quantity ? mealInCart?.quantity + 1 : 1,
        });

        addMealToCart(data);
    }
    const handleRemoveMeal = () => {
        console.log('toggle remove meal', id)
        trackEvent('remove_meal', {
            mealId: id,
            amount: mealInCart?.quantity ? mealInCart?.quantity - 1 : 0,
        });

        removeMealFromCart(data);
    }

    return (
        <div className={styles.mealCard}>
            <div className={styles.mealImage}>
                <img src={imagePath + image} alt={name} />
            </div>
            <div className={styles.mealDetail}>
                <div className={styles.mealName}>{name}</div>
                <div className={styles.mealChef}>
                    <img src={imagePath + chef.avatar} alt={name} />
                    <span>by {`${chef.name} ${chef.lastName}`.trim()}</span>
                </div>
                <div className={styles.mealInfo}>
                    <div>
                        <StarIcon /> 4.2 • {calories} cal
                    </div>
                </div>
            </div>
            <div className={styles.mealActions}>
                {/* depends isFavorite value */}
                {/* <Button onClick={handleToggleFavorite}>
                    <HeartIcon />
                </Button> */}
                {(mealInCart && mealInCart.quantity > 0) ? (
                    <div className={styles.mealQuantity}>
                        <Button onClick={handleRemoveMeal}>
                            <TrashIcon />
                        </Button>
                        <span className={styles.quantity}>{mealInCart.quantity}</span>
                        <Button onClick={handleAddMeal}>
                            <PlusIcon />
                        </Button>
                    </div>
                ) : (
                    <Button onClick={handleAddMeal}>
                        <AddIcon />
                    </Button>
                )}
            </div>
        </div>
    );
};